import React from 'react';

import { useLoginButton } from 'api/google/useLoginButton';

export const GoogleLogin = () => {
  const buttonRef = useLoginButton();

  return (
    <div style={{ height: 40 }} data-cy={'GoogleLoginButton'} ref={buttonRef} />
  );
};
